import { customFetch } from '@/lib/utils';
import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';

type AuthenticatedRequestOptions = {
  accessToken: string;
};

let intercomAlreadyInitialized = false;

const SUPPORT_API_BASE = '/backend/support';

export const Intercom = () => {
  const { user, isAuthenticated, getAccessTokenSilently } = useAuth0();

  useEffect(() => {
    if (!intercomAlreadyInitialized && isAuthenticated && user) {
    const run = async () => {
    const setupIntercom = async ({ accessToken }: AuthenticatedRequestOptions) => {
      const url = new URL(`${SUPPORT_API_BASE}/jwt`, window.location.origin);

      const res = await customFetch(url.toString(), {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
      });

      if (!res.ok) throw await res.json();
      return res.json() as Promise<{ intercom_user_jwt: string }>; // ← returns { intercom_user_jwt }
    };

    const accessToken = await getAccessTokenSilently();
    const { intercom_user_jwt } = await setupIntercom({ accessToken });

    window.intercomSettings = {
      api_base: 'https://api-iam.intercom.io',
      app_id: 'wfl4dckl',
      intercom_user_jwt,
      name: user.name,
      hide_default_launcher: true
    };

    if (typeof window.Intercom === 'function') {
      window.Intercom('update', window.intercomSettings);
    } else {
      const w = window;
      const ic = w.Intercom;
      if (typeof ic === 'function') {
        ic('reattach_activator');
        ic('update', window.intercomSettings);
      } else {
        const d = document;
        const i: any = function () {
          i.c(arguments);
        };
        i.q = [];
        i.c = function (args: any) {
          i.q.push(args);
        };
        w.Intercom = i;
        const l = function () {
          const s = d.createElement('script');
          s.type = 'text/javascript';
          s.async = true;
          s.src = 'https://widget.intercom.io/widget/wfl4dckl';
          const x = d.getElementsByTagName('script')[0];
          x.parentNode.insertBefore(s, x);
        };
        if (d.readyState === 'complete') {
          l();
        } else if (w.attachEvent) {
          w.attachEvent('onload', l);
        } else {
          w.addEventListener('load', l, false);
        }
      }
    }

      intercomAlreadyInitialized = true;
    };
    void run().catch(console.error);
    }
  }, [isAuthenticated, user, getAccessTokenSilently]);

  return <div className="hidden" />;
};
